import { render } from "./CubicationTypes.vue?vue&type=template&id=10ee2fd8"
import script from "./CubicationTypes.vue?vue&type=script&lang=js"
export * from "./CubicationTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__